module.exports = __webpack_public_path__ + "static/sales-pipeline-85099c081f410f1559ca8a69ec79c6e3.png";